import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "file-manager-file-image-preview" */'./FileManagerFileImagePreview').then(mod => mod.default).catch(AsyncComponentErrorHandler('file-manager-file-image-preview')),
  LoadingComponent: () => null
});